export default __webpack_public_path__ + "static/Sunbeam-324e4a47b0669644bf1a7a9816587dcb.jpg";